/**
 * Enllaç de grup (F8 de `plans/guest-data-quality.md`): staff copia un missatge de WhatsApp o
 * correu, en l'idioma de l'hoste, que diu que és un sol formulari per a tot el grup. El text és a
 * `guestPortal.json` → `group.shareMessage` (els quatre idiomes del formulari públic).
 */
const MESSAGE_LANGS = ['ca', 'es', 'en', 'fr'] as const
export type GroupMessageLang = (typeof MESSAGE_LANGS)[number]

/** Idioma del missatge: el de la reserva si en tenim el text (`ja`, `de`… no); si no, anglès */
export function groupMessageLang(lang: string | null | undefined): GroupMessageLang {
  const short = (lang ?? '').trim().slice(0, 2).toLowerCase()
  return (MESSAGE_LANGS as readonly string[]).includes(short) ? (short as GroupMessageLang) : 'en'
}
